module.exports = __webpack_public_path__ + "img/social-media-color-blocks-red.6973920c.png";